import React from "react";
import LoadingIcon from "src/images/animated_loading.gif";

const Loader = () => {
	return (
		<div className="flex-col p-2 mb-4 tab-content-ins flex-cont flex-centered">
			<p>Fetching data, please wait...</p>
			<img src={LoadingIcon} className="loading-img" alt="Loading..." />
		</div>
	);
};

export default Loader;
